/**
 * Centralized error handling for mutations. Log the error and show a toast.
 * Use in useMutation onError or in mutateAsync().catch().
 */
import { appLogger } from '../../shared/utils/logger';
import { DEFAULT_ERROR_TOAST_DURATION_MS, getToastStore } from '../../components/toast/toastStore';
import { issueContextFromApiError, reportIssue } from '../../platform/support/issueReport';

export interface MutationErrorContext {
  mutation?: string;
  [key: string]: unknown;
}

/**
 * Call from mutation onError or in catch blocks. Logs the error and shows an error toast.
 */
export function handleMutationError(error: unknown, context?: MutationErrorContext): void {
  const message = error instanceof Error ? error.message : String(error);
  appLogger.error(message, context);
  const page = typeof context?.page === 'string' ? context.page : 'Mutation';
  const mutation = typeof context?.mutation === 'string' ? context.mutation : 'Unknown mutation';
  reportIssue(
    issueContextFromApiError(page, mutation, error, {
      kind: 'mutation',
      api_endpoint: typeof context?.api_endpoint === 'string' ? context.api_endpoint : undefined,
      http_method: typeof context?.http_method === 'string' ? context.http_method : undefined,
    }),
  );
  getToastStore().show(message, { variant: 'error', duration: DEFAULT_ERROR_TOAST_DURATION_MS });
}
